var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('v-btn',{staticClass:"flex-grow-0",attrs:{"large":"","icon":"","text":"","dark":_vm.dark,"light":!_vm.dark,"color":_vm.color,"width":_vm.size,"height":_vm.size},on:{"click":_vm.nav}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }